import React from 'react'

function AboutPage() {
  return <p>Hello</p>
}

export default AboutPage
